import { render } from "./tencent.vue?vue&type=template&id=f01a15e6"
import script from "./tencent.vue?vue&type=script&lang=js"
export * from "./tencent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__